const FORWARDED_PARAMS = ['commentId', 'debug'];

export const hasNewAppComments = (comments: any[] = []) =>
  comments.some(
    comment => comment?.commentLocation?.position?.innerPath !== undefined,
  );

export const getNewAppClientUrl = ({
  siteUrl,
  feedbackId,
  search,
}: {
  siteUrl: string;
  feedbackId: string;
  search: string;
}) => {
  const url = new URL(siteUrl);
  url.search = '';
  url.hash = '';
  if (!url.pathname.endsWith('/')) {
    url.pathname += '/';
  }
  url.pathname += `__partners-feedback/client/${feedbackId}`;
  const currentParams = new URLSearchParams(search);
  FORWARDED_PARAMS.forEach(param => {
    const value = currentParams.get(param);
    if (value) {
      url.searchParams.set(param, value);
    }
  });
  return url.href;
};
